module.exports = __webpack_public_path__ + "static/img/15.5e27418.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/15.png
// module id = ZI9C
// module chunks = 0